import axios from "axios";

const API_URL = "https://prod-api.youandme.arrowcoders.in";

if (!axios.defaults.baseURL) {
  axios.defaults.baseURL = API_URL;
}
axios.defaults.headers.common["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUser");
      if (typeof window !== "undefined") {
        const path = window.location?.pathname || "/";
        if (path !== "/login") {
          window.location.replace("/login");
        }
      }
    }
    return Promise.reject(error);
  }
);

